export const formBuilderMenuDef = [
    {
        name: 'menu.formBuilder',
        resource: 'formBuilder',
        icon: 'fa fa-h-square',
        url: 'formBuilder',
        breadcrumb: "FormBuilder",
        auto_crud: false
    }
]
